import { Box } from '@chakra-ui/react';
import { Heading, Text, Image } from '@chakra-ui/react';

import logo from '../../presentation/assets/images/shaka.png';
import image from '../../presentation/assets/images/scene1.png';

const Header = () =>
(
    <Box h="580px">
        <Image boxSize="100%" objectFit="cover" src={image} alt="Be Shaka" />
        <Box mt="-480px" align="center">
            <a href="https://shakacrossfit.com" target="_blank" style={{ textDecoration: 'none' }} rel="noopener noreferrer">
                <Image src={logo} mb="60px" maxH="150px" />
            </a>
            <Heading as="h2" size="4xl" color="white">SKILLS</Heading>
            <Text fontFamily="Dead Stock" fontSize="3xl" color="white">SHAKA <span style={{ fontSize: '24px', fontFamily: 'Impact' }}>CrossFit</span></Text>
        </Box>
    </Box>
);

export default Header;